import { useRecoilState, useRecoilValue } from "recoil";
import { tableState } from "../store";

function TablePage(props): JSX.Element {
  const totalPage = useRecoilValue(tableState.totalPage);
  const pages = [...Array(totalPage)].map((v, i) => i + 1);

  const [page, setPage] = useRecoilState(tableState.currentPage);

  return (
    <div className="mt-4">
      <ul className="pagination justify-content-center">
        {pages.map((data) => (
          <li className="page-item">
            <a className="page-link" onClick={() => setPage(data)}>
              {data !== page ? (
                <small className="page-color font-weight-bold text-gray-500">
                  {data}
                </small>
              ) : (
                <small className="page-color paging-icon-style font-weight-bold page_on">
                  {data}
                </small>
              )}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default TablePage;
